import { ready } from '~/core';
import { Http } from '~/utils';

const http = new Http();

ready('svgIcons', '[data-svg]', async icon => {
	let code = await http.get(icon.getAttribute('data-svg')).then(res => res.data);

	icon.insertAdjacentHTML('beforebegin', code);
	icon.parentElement.querySelector('svg').classList = icon.classList;
	icon.parentElement.removeChild(icon);
});
